// extracted by mini-css-extract-plugin
export default {"gray-20":"rgb(221, 224, 230)","divider":"styles_divider__0DmOQ"};